import { LoadBatches } from "../../services/BatchesService";
import * as ActionTypes from "../ActionTypes";
export const LoadBatchesAction = () => {
  return (dispatch) => {
    console.log("yes");
    dispatch({ type: ActionTypes.LOADING });
    LoadBatches().then(
      (res) => {
        if (res.hasOwnProperty("success") && res.success === true) {
          dispatch({ type: ActionTypes.LOAD_BATCHES_SUCCESS, res });
        } else if (res.hasOwnProperty("success") && res.success === false) {
          dispatch({ type: ActionTypes.LOAD_BATCHES_ERROR, res });
        }
      },
      (error) => {
        dispatch({ type: ActionTypes.CODE_ERROR, error });
      }
    );
  };
};
